import { Select, SelectProps } from "antd";
import "./styles.css";
import { DistributionPoint } from "context/MyDistributionPoint";

interface DistributionPointSelectorProps {
  allowedDistributionPoints: DistributionPoint[];
  selectedDistributionPoint: string;
  onChangeDistributionPoint: (value: string) => void;
}

function DistributionPointSelector({
  allowedDistributionPoints,
  selectedDistributionPoint,
  onChangeDistributionPoint,
}: DistributionPointSelectorProps) {
  const filterOption: SelectProps["filterOption"] = (input, option) => {
    const label = option?.label as string;
    return label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  return (
    <div hidden={allowedDistributionPoints.length <= 0}>
      <div style={{ width: "100%", textAlignLast: "center", padding: "5px" }}>
        <Select
          placeholder="Selecciona un Punto de Distribución"
          style={{ width: "95%" }}
          className="PDDSelectorBox"
          onChange={onChangeDistributionPoint}
          value={selectedDistributionPoint}
          showSearch
          filterOption={filterOption}
          options={allowedDistributionPoints.map((dp) => ({
            key: dp.id,
            value: dp.id,
            label: dp.name,
          }))}
        />
      </div>
    </div>
  );
}

export default DistributionPointSelector;
